<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddServiceCategory</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
        
      </div>
      <form [formGroup]="addServiceCategoriesForm" (ngSubmit)="onSubmit()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              
                <div class="form-row" *ngIf="t.controls">
                  <div class="col-6" *ngFor="let ticket of t.controls; let i = index">
                    <div [formGroup]="ticket">
                      <div class="af-form-group">
                        <label for="name" translate>lblServiceCategory<span> in
                            {{Language[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class="lbl-info">
                          <input formControlName="name" class="form-control mb-2" required maxlength="30">
                          <div *ngIf="cpf.service.touched && cpf.service.invalid">
                            <div class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblServiceCategoryRequired
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label class="text" for="languageId" translate>Language Id</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="Language[i].id"
                            placeholder="{{ 'lblServiceCategory' | translate }}" required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-6 af-form-group">
                    <label for="logo" translate>lblOrderNumber</label>
                    <div class='lbl-info'>
                      <input formControlName="OrderNumber" value="" class="form-control" 
                        min="0" maxlength="3" />
                        <div *ngIf="addServiceCategoriesForm.controls['OrderNumber'].invalid && (addServiceCategoriesForm.controls['OrderNumber'].dirty || addServiceCategoriesForm.controls['OrderNumber'].touched)"
                        class="help-block text-danger">
                        <div *ngIf="addServiceCategoriesForm.controls['OrderNumber'].errors.pattern"><span translate>lblOnlyNoAllowed</span>
                        </div>
                        </div>
                    </div>
                  </div>
                <div class="col-6 af-form-group">
                  <label for="logo" translate>lblLogo </label>
                  <div class='lbl-info d-flex align-items-center'>
                    <ng-container *ngIf="image; ">
                      <div class="border mb-3 p-1 d-inline-block mr-3">
                        <img [src]="image | safe:'url' " id="UploadImage" width="50px" class=""
                          onError="this.onerror=null; this.src='../../../../../assets/images/no-image-icon.png'" alt="">
                      </div>
                    </ng-container>
                    <div><span>
                      <label class="btn btn-outline-primary d-inline-block" for="select-files" translate>lblUploadLogo</label>
                      <input type="file" id="select-files" hidden name="FUImage" accept=".png, .jpg, .jpeg, .svg"
                        (change)="onChangeFileUpload($event.target.files)"></span>
                        <span class="ml-2">
                            <button type="button" class="btn btn-outline-primary d-inline-block"
                            translate (click)="RemoveLogo()">lblRemoveLogo</button>
                          </span>
                    <p class="text-muted">
                      <small translate>lblAllowedJPGPNGSVG</small>
                    </p>
                  </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">

        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" [disabled]="!addServiceCategoriesForm.valid"
              translate><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd
            </button>
            <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
          </div>
        </div>
      </div>
      </form>
    </div>
  </div>
</div>